import React from "react";
import { Table } from "react-bootstrap";

const RenderContent = (content) => {
  if (!content) {
    return null;
  }

  const contentView = Object.keys(content).map((k) => {
    if (k.startsWith("element")) {
      const { name, taux, description } = content[k];
      return (
        <tr key={k}>
          <td className="sm">{name}</td>
          <td>{taux || "Taux"}</td>
          <td>{description}</td>
        </tr>
      );
    }

    if (k.startsWith("group") && Array.isArray(content[k].items)) {
      const group = content[k];
      return (
        <>
          <tr key={k + "-label"}>
            <td colSpan="3">
              <strong>{group.label}</strong>: {group.description}
            </td>
          </tr>
          {group.items.map((e, index) => (
            <tr key={index}>
              <td className="sm">{e.name}</td>
              <td>{e.taux}</td>
              <td>{e.description}</td>
            </tr>
          ))}
        </>
      );
    }

    return null;
  });

  return (
    <Table striped bordered hover size="sm">
      <thead>
        <tr>
          <th>Label</th>
          <th>Taux</th>
          <th>Observation</th>
        </tr>
      </thead>
      <tbody>{contentView}</tbody>
    </Table>
  );
};

export default RenderContent;
